<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0"
    xmlns="http://www.w3.org/2000/svg" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet">
    <metadata>
Created by potrace 1.16, written by Peter Selinger 2001-2019
    </metadata>
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
        <path d="M4255 5006 c-204 -208 -399 -316 -686 -380 -261 -58 -568 -60 -1104
-7 -170 17 -404 36 -519 43 -593 32 -1000 -83 -1307 -370 l-72 -68 21 -64 c12
-36 175 -616 363 -1290 188 -674 343 -1227 344 -1228 2 -2 44 31 94 75 201
175 418 276 711 330 79 15 149 18 410 17 267 0 354 -4 575 -27 143 -15 318
-32 390 -37 192 -16 529 -14 666 4 349 47 616 174 843 400 95 95 124 139 132
198 11 83 7 88 -133 163 -250 133 -497 302 -731 501 -62 53 -115 106 -118 119
-3 12 17 114 45 226 97 396 173 780 227 1157 19 134 34 268 32 296 -3 51 -3
51 -38 53 -32 1 -44 -7 -145 -111z"/>
        <path d="M152 4245 c-97 -30 -151 -104 -152 -204 0 -42 126 -506 541 -1990
297 -1065 548 -1951 556 -1969 26 -54 77 -82 149 -82 159 0 274 80 274 191 0
35 -1083 3917 -1105 3959 -21 41 -81 87 -131 99 -54 14 -78 13 -132 -4z"/>
        <path d="M3845 1352 c-16 -11 -47 -38 -67 -60 -33 -36 -38 -49 -38 -89 l0 -47
212 -213 212 -213 -212 -213 -212 -213 0 -47 c0 -42 5 -53 42 -93 51 -55 85
-74 134 -74 36 0 50 12 251 212 l213 212 213 -212 c201 -200 215 -212 251
-212 49 0 83 19 134 74 37 40 42 51 42 93 l0 47 -212 213 -212 213 212 213
212 213 0 47 c0 42 -5 53 -42 93 -51 55 -85 74 -134 74 -36 0 -50 -12 -251
-212 l-213 -212 -213 212 c-205 204 -214 212 -253 212 -21 0 -52 -8 -69 -18z"/>
    </g>
</svg>